var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"empty-task",style:({
    'top': _vm.emptyBarInfo._top + 'px',
    'left': _vm.emptyBarInfo._left + 'px',
    'width': _vm.emptyBarInfo._width + 'px',
    'height': _vm.emptyBarInfo._height + 'px',
    'background-color': _vm.emptyBarInfo._bgColor,
  })},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.emptyBarInfo.labelIsShow && _vm.emptyBarInfo._width >= 20),expression:"emptyBarInfo.labelIsShow && emptyBarInfo._width >= 20"}],staticClass:"empty-task-info",attrs:{"title":_vm.emptyBarInfo.innerDesc}},[_vm._v(_vm._s(_vm.emptyBarInfo.innerDesc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }